var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 9.86914H11.375C10.2704 9.86914 9.375 10.7646 9.375 11.8691V20.8691C9.375 21.9737 10.2704 22.8691 11.375 22.8691H20.375C21.4796 22.8691 22.375 21.9737 22.375 20.8691V11.8691C22.375 10.7646 21.4796 9.86914 20.375 9.86914Z",
    stroke: "#351771",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 15.8691H4.375C3.84457 15.8691 3.33586 15.6584 2.96079 15.2834C2.58571 14.9083 2.375 14.3996 2.375 13.8691V4.86914C2.375 4.33871 2.58571 3.83 2.96079 3.45493C3.33586 3.07985 3.84457 2.86914 4.375 2.86914H13.375C13.9054 2.86914 14.4141 3.07985 14.7892 3.45493C15.1643 3.83 15.375 4.33871 15.375 4.86914V5.86914",
    stroke: "#351771",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.016128d45c687d447f974e8ceb0224a7.svg";
export { ForwardRef as ReactComponent };